<template>
  <section id="urine-culture-panel-selected" class="selected-test-preview">
    <div class="test-panel-name">
      <p class="name">Selected Panels</p>
      <p class="viewPanel" @click="showUrineCultureTests">{{ this.urineCulturePanelTitle }}</p>
    </div>

    <div class="default-modal" v-if="urineCultureTestsPopup">
      <el-dialog v-model="urineCultureTestsPopup">
        <div class="dialog-header">
          <span class="header-part">Urine Culture</span>
          <el-button size="medium" class="el-white" type="info" plain @click="urineCultureTestsPopup = false">
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
          </el-button>
        </div>
        <div class="popup-panels-blocks">
          <ul>
            <li
              class="toxicology-text-panels"
              v-for="(category, index) of getCaseCategoryData()"
              :key="index"
            >
              <h3 class="test-group-title">
                {{ category.panel_title }}
              </h3>
              <ul class="check-list-woundpanel">
                <li
                  v-for="(item, index) of getCategoryWiseTestsData(
                    'URINE_CULTURE',
                    category.panel_id,
                    category.group_id
                  )"
                  :key="index"
                >
                  <el-checkbox-group v-model="panelsTestsData.selectedTestIds">
                    <el-checkbox :label="item._id" :value="item" disabled>{{
                      item.test_name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
import { mapGetters } from "vuex";

export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {},
  props: ["panelTestsData", "test", "allSelectedTests"],

  data() {
    return {
      urineCulturePanelTitle: "",
      urineCultureGroupId: "",
      selectedUrineCulturePanels: [],
      loading: false,
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
      allTests: "",
      urineCultureTestsPopup: false,
    };
  },

  mounted() {
    this.loading = true;
    this.allTests = this.allSelectedTests;
    this.panelsTestsData = this.panelTestsData;
    try {
      this.getSelectedGroupTitle();
    } catch (err) {
      console.log(err);
    }
    this.loading = false;
  },

  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
      "getNewLabGroupWiseTestsData",
    ]),
  },

  methods: {
    showUrineCultureTests() {
      this.urineCultureTestsPopup = true;
    },

    getCategoryWiseTestsData(caseType, category, group_id) {
      return this.getNewLabGroupPanelTests.filter(
        (el) =>
          el.case_type_code == caseType &&
          el.panel_id == category &&
          el.group_id == group_id
      );
    },

    getCaseCategoryData() {
      let data = this.getNewLabGroupPanelTests.filter(
        (e) =>
          this.urineCultureGroupId == e.group_id &&
          this.selectedUrineCulturePanels.includes(e.panel_id)
      );

      return data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    },

    getSelectedGroupTitle() {
      let selectedGroup = this.panelsTestsData.selectedGroup.filter(
        (e) => e.case_type_code == "URINE_CULTURE"
      );

      if (selectedGroup.length) {
        const selectedGroupId = selectedGroup[0].group_id;

        const matchedGroup = this.getNewLabGroupWiseTests.find(
          (group) => group._id == selectedGroupId
        );

        this.urineCulturePanelTitle = matchedGroup?.group_title || "No matching group";
        this.urineCultureGroupId = matchedGroup?.group_id;

        if (
          matchedGroup?.panel_ids &&
          matchedGroup?.panel_ids.length > 0 &&
          typeof matchedGroup?.panel_ids[0] == "string"
        ) {
          this.selectedUrineCulturePanels = matchedGroup?.panel_ids;
        } else {
          this.selectedUrineCulturePanels = matchedGroup?.panel_ids.map((e) => e._id);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#urine-culture-panel-selected {
  .default-modal {
    .popup-panels-blocks {
      ul {
        .toxicology-text-panels {
          .check-list-woundpanel {
            li {
              .el-checkbox-group {
                .el-checkbox {
                  white-space: normal;
                  .el-checkbox__label {
                    line-height: 16px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
